import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { AppButton } from 'shared/UI/UIKit/Button';
import { scheduleConstraintLabels } from 'features/schedule-configuration/model/utils';
import type { ImprovedScheduleConstraint } from 'features/schedule/redux';
import type { ScheduleConstraintCode } from 'services/api';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import styles from '../../../styles.module.scss';

export const getColumns = (
  toggleConstraintVisibility: (code: ScheduleConstraintCode) => void,
): AppTableColumn<ImprovedScheduleConstraint>[] => {
  return [
    {
      key: 'action',
      title: 'Действие',
      dataIndex: [],
      render: (_, record) => (
        <AppButton
          icon={record.isVisible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
          onClick={() => toggleConstraintVisibility(record.code)}
          disabled={record.isDisabled}
          type="text"
          className={classNames(styles.constraintsButton, {
            [styles.constraintsButton_highlighted]: record.isHighlighted,
          })}
        />
      ),
    },
    {
      key: 'code',
      title: 'Код',
      dataIndex: ['code'],
      render: (code: ScheduleConstraintCode, record) => (
        <span className={record.isDisabled ? styles.constraintsCode_disabled : ''}>
          {scheduleConstraintLabels[code]}
        </span>
      ),
    },
  ];
};
